export const ONBOARDING_TRANSITION_DURATION_MS = 400;
